export const coreConfig = {
  apiBaseUrl: 'http://localhost:443',
};
